<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        
        <!-- SECCIÓN SUPERIOR: Gráficos (círculo, muñeca, moño) -->
        <div class="top-graphics-wrapper">
          <img
            ref="circuloRef"
            src="@/assets/circuuu.png"
            alt="Círculo de Rosas"
            class="circulo-img"
          >
          <img
            ref="quinceaneraRef"
            src="@/assets/quinceañera.png"
            alt="Quinceañera"
            class="quinceanera-img"
          >
          <img
            ref="monoRef"
            src="@/assets/mariposa.png"
            alt="Moño Rojo"
            class="mono-img"
          >
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'InvitacionQuinceanera',
  setup() {
    // Referencias HTML activas
    const fotoPortadaRef = ref(null)
    const circuloRef = ref(null)
    const quinceaneraRef = ref(null)
    const monoRef = ref(null)

    onMounted(() => {
      // ---------------------------------------------------------
      // ANIMACIÓN DE ENTRADA PRINCIPAL PARA ELEMENTOS ACTIVOS
      // ---------------------------------------------------------
      gsap.from(fotoPortadaRef.value, { 
        opacity: 0, 
        y: 80, 
        duration: 1.4, 
        ease: 'power3.out' 
      })

      const tl = gsap.timeline({ delay: 0.8 });

      tl.fromTo(
        circuloRef.value, 
        { opacity: 0, y: -150, scale: 1.8, filter: 'blur(15px)' }, 
        { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1.8, ease: 'power4.out' }, 
        0
      );

      tl.from(
        quinceaneraRef.value, 
        { opacity: 0, y: 50, duration: 1.5, ease: 'power3.out' }, 
        0.8
      );

      tl.from(
        monoRef.value, 
        { opacity: 0, scale: 0, duration: 1.2, ease: 'back.out(1.8)' }, 
        1.2
      );
    })

    return {
      fotoPortadaRef,
      circuloRef,
      quinceaneraRef,
      monoRef
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. ESTILOS BASE Y CONTENEDORES
   ========================================== */
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 52vh;
  overflow: visible;
  background-color: #fff;;
 margin-top:-60px;
 margin-bottom: 100px;
  background-repeat: no-repeat;
  background-position: center bottom;
  z-index: 1;
}

.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 40px;
  z-index: 2;
}

/* ==========================================
   2. GRÁFICOS SUPERIORES
   ========================================== */
.top-graphics-wrapper {
  position: relative;
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  z-index: 3;
}

.circulo-img {
  width: 100%;
  max-width: 350px;
  height: auto;
  position: relative;
  z-index: 1;
}

.quinceanera-img {
  width: 90%;
  max-width: 460px;
  height: auto;
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.mono-img {
  width: 10%;
  max-width: 150px;
  height: auto;
  margin-top: 16px;
  position: relative;
  z-index: 3;
}

/* ==========================================
   3. TEXTOS Y CONTENIDO CENTRAL
   ========================================== */
.centered-content {
  text-align: center;
  color: #8C6F4D;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top:-40px;
  z-index: 4;
}

.lets-honor-text {
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #B28F60;
}

.quinceanera-title {
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #B28F60;
  margin-top: -5px;
}

.nombre-principal {
  font-family: 'CynthiaJuneJF', serif;
  font-size: 85px;
  font-weight: 500;
  line-height: 1;
  color: #9C1B2C;
  margin: 15px 0;
}

/* ==========================================
   4. SECCIÓN FECHA
   ========================================== */
.fecha-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #B28F60;
  margin-bottom: 25px;
}

.fecha-linea-superior {
  display: flex;
  align-items: center;
  gap: 25px;
}

.fecha-mes-texto,
.fecha-hora-texto {
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

.fecha-dia-numero {
  font-family: 'CynthiaJuneJF', serif;
  font-size: 55px;
  font-weight: 500;
  line-height: 1;
  color: #9C1B2C;
}

.fecha-anio-numero {
  font-family: 'CynthiaJuneJF', serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 1;
  color: #9C1B2C;
}

/* ==========================================
   5. BOTÓN GOOGLE MAPS
   ========================================== */
.google-maps-btn {
  display: inline-block;
  padding: 10px 25px;
  background-color: white;
  border: 2px solid #D8C7B0;
  border-radius: 25px;
  color: #9C1B2C;
  text-transform: uppercase;
  font-family: 'Playfair Display', serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-decoration: none;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.google-maps-btn:hover {
  background-color: #F8F4EE;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* ==========================================
   6. 🎭 MÁSCARA LADO IZQUIERDO
   ========================================== */
.mascara-left-container {
  position: absolute;
  top: 5%;
  left: 10%;
  pointer-events: none;
  z-index: 5;
}

.mascara-img-left {
  width: 210px;
  height: auto;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
  transform: rotate(-15deg);
}

@keyframes flotacionSuave {
  0%, 100% {
    transform: translateY(0px) rotate(-15deg);
  }
  50% {
    transform: translateY(-8px) rotate(-12deg);
  }
}

.flotacion-suave {
  animation: flotacionSuave 3s infinite ease-in-out;
}

/* ==========================================
   7. 🦋 MARIPOSAS Y ANIMACIÓN
   ========================================== */
.butterflies-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 100;
  margin-top: 40px;
  margin-right: 40px !important;

  overflow: hidden;
  perspective: 1000px;
}

.mariposa-img {
  position: absolute;
  width: 120px !important;
  height: auto;
  opacity: 1 !important;
  will-change: transform;
  transform-origin: center bottom;
}

/* Keyframes de Aleteo */
@keyframes vueloSuave {
  0%, 100% {
    /* Estado normal: alas abiertas */
    transform: translateY(0px) scaleX(1);
  }
  50% {
    /* Pliegue delicado (-25%) y elevación de 3px */
    transform: translateY(-3px) scaleX(0.75);
  }
}

.vuelo-suave {
  /* Modifica aquí la velocidad (ej: 0.5s, 0.8s, 1s) */
  animation: vueloSuave 0.6s infinite ease-in-out;
}
</style>